import { jsx } from 'react/jsx-runtime';
import { C as CustomisedTooltip } from './InformationTooltip-7059c75f.js';

var getPropertyFromObj = function (obj, path) {
    var _a, _b;
    var splittedPath = (_a = path === null || path === void 0 ? void 0 : path.split('.')) !== null && _a !== void 0 ? _a : [];
    return (_b = splittedPath.reduce(function (acc, fieldName) {
        var _a;
        return (_a = acc && acc[fieldName]) !== null && _a !== void 0 ? _a : undefined;
    }, obj)) !== null && _b !== void 0 ? _b : undefined;
};

var ValidationErrorTooltip = function (props) {
    var _a;
    var message = '';
    var disableTooltip = true;
    if (props.property && getPropertyFromObj(props.errors, props.property) && (typeof props.touched === 'undefined' || getPropertyFromObj(props.touched, props.property))) {
        if (typeof props.errors[props.property] === 'object') {
            var errorObject_1 = props.errors[props.property];
            var keys = Object.keys(errorObject_1);
            keys.forEach(function (key) {
                message += errorObject_1[key] + ' ';
            });
        } else {
            message = props.errors[props.property];
        }
        message = getPropertyFromObj(props.errors, props.property);
        disableTooltip = false;
    }
    return jsx(CustomisedTooltip, { placement: "top", title: message, disableHoverListener: disableTooltip, disableFocusListener: disableTooltip, disableTouchListener: disableTooltip, children: jsx("div", { className: (_a = props === null || props === void 0 ? void 0 : props.valueClasses) !== null && _a !== void 0 ? _a : '', children: props.children }) });
};

export { ValidationErrorTooltip as V, getPropertyFromObj as g };
